/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs */

const en_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cannot create folder in this view`)
};

const fr_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de creer un dossier dans cette vue`)
};

const de_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In dieser Ansicht kann kein Ordner erstellt werden.`)
};

const it_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile creare la cartella in questa vista`)
};

const ru_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В этом представлении невозможно создать папку.`)
};

const es_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se puede crear una carpeta en esta vista`)
};

const zh_cn2_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此视图中无法创建文件夹。`)
};

const ja_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このビューではフォルダを作成できません`)
};

const hi_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस व्यू में फ़ोल्डर नहीं बनाया जा सकता`)
};

const pt_pt2_explorer_nav_create_folder_not_allowed_toast = /** @type {(inputs: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não é possível criar pasta nesta visualização.`)
};

/**
* | output |
* | --- |
* | "Cannot create folder in this view" |
*
* @param {Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_create_folder_not_allowed_toast = /** @type {((inputs?: Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_Create_Folder_Not_Allowed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_create_folder_not_allowed_toast(inputs)
	if (locale === "de") return de_explorer_nav_create_folder_not_allowed_toast(inputs)
	if (locale === "it") return it_explorer_nav_create_folder_not_allowed_toast(inputs)
	if (locale === "ru") return ru_explorer_nav_create_folder_not_allowed_toast(inputs)
	if (locale === "es") return es_explorer_nav_create_folder_not_allowed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_create_folder_not_allowed_toast(inputs)
	if (locale === "ja") return ja_explorer_nav_create_folder_not_allowed_toast(inputs)
	if (locale === "hi") return hi_explorer_nav_create_folder_not_allowed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_create_folder_not_allowed_toast(inputs)
	return en_explorer_nav_create_folder_not_allowed_toast(inputs)
});